import { Action } from '@ngrx/store'
import { User, UserAccess } from './user.model'
import * as UserActions from './user.actions'

/**
 * Initial state for a user
 */
const initialState: User = {
    name: "Jared Stevens",
    username: "",
    email: "",
    brand: "",
    company: "",
    dateUpdated: new Date(),
    isGlobalAdmin: false,
    isLeader: false,
    access: []
}

/**
 * Reducer function for managing user state.
 * @param state Current state (initialized with initialState by default)
 * @param action Action dispatched to update state
 * @returns Updated state
 */
export function reducer(state: User[] = [initialState], action: UserActions.Actions) {
    switch (action.type) {
        case UserActions.ADD_USER:
            return [...state, action.payload];
        case UserActions.UPDATE_USER:
            return [...state, action.payload];
        default:
            return state;
    }
}
